













 
















const node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reflectionGroupId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v2 = [
  {
    "kind": "Variable",
    "name": "reflectionGroupId",
    "variableName": "reflectionGroupId"
  },
  {
    "kind": "Variable",
    "name": "title",
    "variableName": "title"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "titleIsUserDefined",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateReflectionGroupTitleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "UpdateReflectionGroupTitlePayload",
        "kind": "LinkedField",
        "name": "updateReflectionGroupTitle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RetroReflectionGroup",
            "kind": "LinkedField",
            "name": "reflectionGroup",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateReflectionGroupTitleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "UpdateReflectionGroupTitlePayload",
        "kind": "LinkedField",
        "name": "updateReflectionGroupTitle",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "RetroReflectionGroup",
            "kind": "LinkedField",
            "name": "reflectionGroup",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "m_L6H_OgS7OMCOgaHrpmkFeg",
    "metadata": {},
    "name": "UpdateReflectionGroupTitleMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node ).hash = "99e7a7f3dc1d63b096f90ab2032e5ae4";

export default node;
